import { useTaskCalendarSyncControls } from '@griply/hooks';
import { CalendarTaskSync } from '@griply/types';
import React from 'react';
import { CalendarEventSyncBadge } from 'shared/components/ui/calendar-event-sync-badge';
import { getTaskCheckboxColor } from 'shared/components/ui/checkbox';
import { Task } from 'shared/types/task';

export type TaskEventSyncBadgeProps = {
  task: Task;
  calendarSync?: CalendarTaskSync;
  color?: string;
};

// The trailing affordance shared by every task event card (basic + each timeslot
// kind). Renders nothing when no calendar could host the task.
export const TaskEventSyncBadge: React.FC<TaskEventSyncBadgeProps> = ({
  task,
  calendarSync,
  color,
}) => {
  const { syncState, toggleSync, toggleVisibility } =
    useTaskCalendarSyncControls(task, calendarSync);

  if (!syncState) {
    return null;
  }

  return (
    <CalendarEventSyncBadge
      isSynced={syncState.isSynced}
      isHidden={syncState.isHidden}
      onToggleSync={toggleSync}
      onToggleVisibility={toggleVisibility}
      color={getTaskCheckboxColor(color, task.priority)}
    />
  );
};
